import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/img/icons/dashboard/animated-black-arrow.svg';
import _imports_1 from '@/assets/img/icons/dashboard/blue-right-arrow.svg';
import _imports_2 from '@/assets/img/builder/close-white-sm.svg';
import _imports_3 from '@/assets/img/icons/tick-success-fill.svg';
import _imports_4 from '@/assets/img/icons/dashboard/arrow-circle-right-primary.svg';
import _imports_5 from '@/assets/img/icons/dashboard/info-yellow-animated.svg';
import _imports_6 from '@/assets/img/icons/menu/upgrade-icon.svg';
import _imports_7 from '@/assets/img/icons/menu/transational.svg';
import _imports_8 from '@/assets/img/icons/menu/transational-hover.svg';
import _imports_9 from '@/assets/img/icons/menu/drop-ico-profile.svg';
import _imports_10 from '@/assets/img/icons/menu/drop-ico-billing.svg';
import _imports_11 from '@/assets/img/icons/menu/drop-ico-settings.svg';
import _imports_12 from '@/assets/img/icons/menu/drop-ico-domains.svg';
import _imports_13 from '@/assets/img/icons/menu/drop-ico-log.svg';
import _imports_14 from '@/assets/img/icons/menu/help.svg';
import _imports_15 from '@/assets/img/icons/menu/log-out.svg';
import _imports_16 from '@/assets/img/icons/menu/menu-toggle-ico.svg';
import _imports_17 from '@/assets/img/icons/menu/menu-close.svg';
import _imports_18 from '@/assets/img/icons/menu-opener.png';
import _imports_19 from '@/assets/img/icons/menu-closer.png';
const _hoisted_1 = {
  class: "container-fluid d-none d-md-flex"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "navbar-toggler-icon"
}, null, -1);
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "nav-link-text nav-logo-text"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "navbar-collapse collapse show",
  id: "sidenav-collapse-main"
};
const _hoisted_7 = {
  class: "navbar-nav flex-end"
};
const _hoisted_8 = {
  class: "nav-noti-li hover-img"
};
const _hoisted_9 = {
  href: "javascript:void(0)",
  class: "nav-link d-flex align-self-center nav-noti",
  id: "popoverMenuNoti"
};
const _hoisted_10 = {
  class: "nav-noti"
};
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<span class=\"label\"><span class=\"vh-center position-absolute\"><img src=\"" + _imports_0 + "\" alt=\"\" width=\"18\" class=\"hover-none\"><img src=\"" + _imports_1 + "\" alt=\"\" width=\"18\" class=\"hover-visible\"></span></span><div class=\"pie\"><div class=\"left-side half-circle\"></div><div class=\"right-side half-circle\"></div></div><div class=\"shadow\"></div>", 3);
const _hoisted_14 = [_hoisted_11];
const _hoisted_15 = {
  class: "nav-link-text"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0 mt-0 font-13 fw-bold"
}, "Basic setup", -1);
const _hoisted_17 = {
  class: "mb-0 font-12"
};
const _hoisted_18 = {
  class: "dark-tooltip pop-menu-noti"
};
const _hoisted_19 = {
  ref: "popNoti"
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "9"
}, null, -1);
const _hoisted_21 = [_hoisted_20];
const _hoisted_22 = {
  class: "font-13 fw-bold mb-2"
};
const _hoisted_23 = {
  class: "list-unstyled menu-step-ul"
};
const _hoisted_24 = {
  key: 0,
  src: _imports_3,
  class: "success-img",
  width: "24"
};
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "arrow-link"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  width: "18"
})], -1);
const _hoisted_26 = {
  class: "state-ico order"
};
const _hoisted_27 = {
  key: 0,
  class: "d-flex vh-center position-absolute"
};
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  width: "24"
}, null, -1);
const _hoisted_29 = [_hoisted_28];
const _hoisted_30 = {
  key: 1,
  src: _imports_3,
  class: "success-img",
  width: "24"
};
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  class: "arrow-link"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  width: "18"
})], -1);
const _hoisted_32 = ["title"];
const _hoisted_33 = {
  key: 0,
  src: _imports_3,
  class: "success-img",
  width: "24"
};
const _hoisted_34 = {
  key: 1,
  src: _imports_5,
  width: "24"
};
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", {
  class: "arrow-link"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  width: "18"
})], -1);
const _hoisted_36 = ["title"];
const _hoisted_37 = {
  class: "state-ico order"
};
const _hoisted_38 = {
  key: 0,
  src: _imports_3,
  class: "success-img",
  width: "24"
};
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", {
  class: "arrow-link"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  width: "18"
})], -1);
const _hoisted_40 = {
  key: 0,
  class: "nav-item upgrade-navitem overflow-hidden"
};
const _hoisted_41 = {
  class: "upgrade-navitem-inner"
};
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", {
  class: "ico-sidebar upgrade-holder"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "upgrade",
  width: "24"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "upgrade-hover-icon",
  width: "24"
})], -1);
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text"
}, "Upgrade Plan", -1);
const _hoisted_44 = {
  key: 1,
  class: "nav-item te-navitem overflow-hidden"
};
const _hoisted_45 = {
  class: "te-navitem-inner"
};
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", {
  class: "ico-sidebar transational-holder rounded-circle bg-grey-60"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "platform-icon",
  width: "24",
  alt: "transational"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "platform-hover-icon",
  width: "24",
  alt: "transational hover"
})], -1);
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "m-0 text-sub-head text-22"
}, "API Platform")], -1);
const _hoisted_48 = {
  class: "nav-item overflow-hidden"
};
const _hoisted_49 = {
  key: 1,
  class: "round-32 letteravatarbg"
};
const _hoisted_50 = {
  class: "nav-link-text"
};
const _hoisted_51 = {
  class: "m-0 text-sub-head text-truncate wid-8-em text-22"
};
const _hoisted_52 = {
  class: "nav-user-drop"
};
const _hoisted_53 = {
  class: "py-3"
};
const _hoisted_54 = {
  class: "media"
};
const _hoisted_55 = {
  key: 0,
  class: "d-flex align-self-center"
};
const _hoisted_56 = {
  class: "position-relative line-h-0"
};
const _hoisted_57 = {
  key: 1,
  class: "d-flex align-self-center"
};
const _hoisted_58 = {
  class: "round-32 letteravatarbg"
};
const _hoisted_59 = {
  class: "media-body align-self-center min-100 ms-3"
};
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  width: "18",
  class: "align-middle",
  alt: "billing"
})]), /*#__PURE__*/_createElementVNode("span", null, "Profile")], -1);
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  width: "18",
  class: "align-middle",
  alt: "billing"
})]), /*#__PURE__*/_createElementVNode("span", null, "Billing")], -1);
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  width: "18",
  class: "align-middle",
  alt: "settings"
})]), /*#__PURE__*/_createElementVNode("span", null, "Account")], -1);
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  width: "18",
  class: "align-middle",
  alt: "domains"
})]), /*#__PURE__*/_createElementVNode("span", null, "Domains")], -1);
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  width: "18",
  class: "align-middle",
  alt: "log"
})]), /*#__PURE__*/_createElementVNode("span", null, "Logs")], -1);
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  width: "18",
  class: "align-middle",
  alt: "help"
})]), /*#__PURE__*/_createElementVNode("span", null, "Help Center")], -1);
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  width: "18",
  class: "align-middle",
  alt: "Log out"
})]), /*#__PURE__*/_createElementVNode("span", null, "Sign Out")], -1);
const _hoisted_67 = {
  class: "d-md-none w-100"
};
const _hoisted_68 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  width: "20",
  alt: ""
}, null, -1);
const _hoisted_69 = [_hoisted_68];
const _hoisted_70 = ["src"];
const _hoisted_71 = {
  key: 0,
  class: "mobile-menu-container"
};
const _hoisted_72 = ["src"];
const _hoisted_73 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  width: "24"
}, null, -1);
const _hoisted_74 = [_hoisted_73];
const _hoisted_75 = {
  class: "d-flex align-items-start flex-column mob-menu-height"
};
const _hoisted_76 = {
  class: "navbar-nav mt-auto text-left"
};
const _hoisted_77 = {
  class: "nav-item"
};
const _hoisted_78 = {
  key: 1,
  class: "round-32 letteravatarbg"
};
const _hoisted_79 = {
  class: "nav-link-text"
};
const _hoisted_80 = {
  class: "m-0 text-sub-head text-truncate wid-8-em fw-bold text-22"
};
const _hoisted_81 = {
  key: 0,
  class: "user-card-menu-container"
};
const _hoisted_82 = {
  class: "user-card-menu"
};
const _hoisted_83 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  width: "24",
  alt: "close"
}, null, -1);
const _hoisted_84 = [_hoisted_83];
const _hoisted_85 = {
  class: "nav-user-drop"
};
const _hoisted_86 = {
  class: "py-3"
};
const _hoisted_87 = {
  class: "media"
};
const _hoisted_88 = {
  key: 0,
  "vertical-align": "center"
};
const _hoisted_89 = {
  class: "position-relative line-h-0"
};
const _hoisted_90 = {
  key: 1,
  class: "media",
  "vertical-align": "center"
};
const _hoisted_91 = {
  class: "round-32 letteravatarbg"
};
const _hoisted_92 = {
  class: "align-self-center min-100 ml-3 media-body"
};
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  width: "18",
  class: "align-middle",
  alt: "billing"
})]), /*#__PURE__*/_createElementVNode("span", null, "Profile")], -1);
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  width: "18",
  class: "align-middle",
  alt: "billing"
})]), /*#__PURE__*/_createElementVNode("span", null, "Billing")], -1);
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  width: "18",
  class: "align-middle",
  alt: "settings"
})]), /*#__PURE__*/_createElementVNode("span", null, "Account")], -1);
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  width: "18",
  class: "align-middle",
  alt: "domains"
})]), /*#__PURE__*/_createElementVNode("span", null, "Domains")], -1);
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  width: "18",
  class: "align-middle",
  alt: "log"
})]), /*#__PURE__*/_createElementVNode("span", null, "Logs")], -1);
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  width: "18",
  class: "align-middle",
  alt: "help"
})]), /*#__PURE__*/_createElementVNode("span", null, "Help Center")], -1);
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "nav-drop-ico"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  width: "18",
  class: "align-middle",
  alt: "Log out"
})]), /*#__PURE__*/_createElementVNode("span", null, "Sign Out")], -1);
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", {
  class: "menu-open-close"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  class: "open",
  width: "25"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  class: "close",
  width: "25"
})], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_navbar_toggle_button = _resolveComponent("navbar-toggle-button");
  const _component_b_link = _resolveComponent("b-link");
  const _component_b_progress_bar = _resolveComponent("b-progress-bar");
  const _component_b_progress = _resolveComponent("b-progress");
  const _component_b_popover = _resolveComponent("b-popover");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
  const _component_BPopover = _resolveComponent("BPopover");
  const _component_mob_menu = _resolveComponent("mob-menu");
  return _openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white", {
      active: $data.active
    }]),
    id: "sidenav-main"
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_navbar_toggle_button, {
    onClick: $options.showSidebar
  }, {
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_b_link, {
    class: "navbar-brand",
    href: "/"
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      src: require('@/assets/img/icons/menu/mailercloud/brand-icon.svg'),
      class: "navbar-brand-img brand-icon",
      width: "42",
      alt: "..."
    }, null, 8, _hoisted_3), _createElementVNode("span", _hoisted_4, [_createElementVNode("img", {
      src: require('@/assets/img/icons/menu/text-logo.svg'),
      alt: "..."
    }, null, 8, _hoisted_5)])]),
    _: 1
  }), _renderSlot(_ctx.$slots, "default"), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("ul", {
    class: _normalizeClass(["navbar-nav nav-overflow scroll-bar", {
      'nav-overflow-te': $data.permission < 2 && $data.allowTransaction,
      'nav-overflow-wlc': parseInt($options.isWelcomeDashboard) !== 2
    }])
  }, [_renderSlot(_ctx.$slots, "links")], 2)], 512), [[_vShow, $options.showSidebar]]), _createElementVNode("ul", _hoisted_7, [_withDirectives(_createElementVNode("li", _hoisted_8, [_createElementVNode("a", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: _normalizeClass(["pie-wrapper", 'progress-' + $options.getProgress])
  }, _hoisted_14, 2)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("p", _hoisted_17, "Set " + _toDisplayString($options.stageCompleted) + " of 4", 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, null, 512)])]), _createVNode(_component_b_popover, {
    target: "popoverMenuNoti",
    triggers: "hover",
    placement: "top",
    container: $setup.popNoti,
    show: $data.showPopNoti,
    "no-fade": "",
    "custom-class": "dark-tooltip",
    delay: "0"
  }, {
    default: _withCtx(() => [_createElementVNode("span", {
      class: "pop-close d-none",
      onClick: _cache[0] || (_cache[0] = $event => $data.showPopNoti = !$data.showPopNoti)
    }, _hoisted_21), _createElementVNode("p", _hoisted_22, " You are just " + _toDisplayString($options.getPending) + " " + _toDisplayString($options.getPending > 1 ? "steps" : "step") + " away! ", 1), _createVNode(_component_b_progress, {
      height: "6px",
      max: 100,
      class: "mb-3 radius-4"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_progress_bar, {
        value: $options.getProgress,
        variant: "primary"
      }, null, 8, ["value"])]),
      _: 1
    }), _createElementVNode("ul", _hoisted_23, [_createElementVNode("li", {
      onClick: _cache[1] || (_cache[1] = $event => $options.goTo('contact')),
      class: _normalizeClass({
        completed: $options.welcomeDashboardItems.addContact === 2,
        current: $options.getCurrentClass === 'addContact'
      })
    }, [_createElementVNode("span", {
      class: _normalizeClass(["state-ico", $options.welcomeDashboardItems.addContact !== 2 ? 'order' : ''])
    }, [$options.welcomeDashboardItems.addContact === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_24)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($options.welcomeDashboardItems.addContact === 2 ? "" : 1), 1)], 2), _createTextVNode(" " + _toDisplayString($options.welcomeDashboardItems.addContact === 2 ? "Audience added" : "Add your audience") + " ", 1), _hoisted_25], 2), _createElementVNode("li", {
      onClick: _cache[2] || (_cache[2] = $event => $options.goTo('domain')),
      class: _normalizeClass({
        completed: $options.welcomeDashboardItems.addDomain === 2,
        current: $options.getCurrentClass === 'addDomain',
        loading: $options.welcomeDashboardItems.addDomain === 1
      })
    }, [_createElementVNode("span", _hoisted_26, [$options.welcomeDashboardItems.addDomain === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_29)) : _createCommentVNode("", true), $options.welcomeDashboardItems.addDomain === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_30)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($options.welcomeDashboardItems.addDomain === 2 ? "" : 2), 1)]), _createTextVNode(" " + _toDisplayString($options.welcomeDashboardItems.addDomain === 2 ? "Domain authenticated" : $options.welcomeDashboardItems.addDomain === 1 ? "Checking domain status" : "Authenticate domain") + " ", 1), _hoisted_31], 2), _createElementVNode("li", {
      onClick: _cache[3] || (_cache[3] = $event => $options.goTo('senderId')),
      title: $options.getStepDisableClass('senderId') === true ? 'Please complete the previous steps' : '',
      class: _normalizeClass({
        'step-disabled': $options.getStepDisableClass('senderId') === true,
        completed: $options.welcomeDashboardItems.addSenderId === 2,
        current: $options.getCurrentClass === 'addSenderId'
      })
    }, [_createElementVNode("span", {
      class: _normalizeClass(["state-ico", $options.welcomeDashboardItems.addSenderId === 0 ? 'order' : ''])
    }, [$options.welcomeDashboardItems.addSenderId === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_33)) : _createCommentVNode("", true), $options.welcomeDashboardItems.addSenderId === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_34)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($options.welcomeDashboardItems.addSenderId === 0 ? 3 : ""), 1)], 2), _createTextVNode(" " + _toDisplayString($options.welcomeDashboardItems.addSenderId === 2 ? "Sender ID verified" : $options.welcomeDashboardItems.addSenderId === 1 ? "Verify your sender ID " : "Create your sender ID") + " ", 1), _hoisted_35], 10, _hoisted_32), _createElementVNode("li", {
      onClick: _cache[4] || (_cache[4] = $event => $options.goTo('campaign')),
      title: $options.getStepDisableClass('campaign') === true ? 'Please complete the previous steps' : '',
      class: _normalizeClass({
        'step-disabled': $options.getStepDisableClass('campaign') === true,
        completed: $options.welcomeDashboardItems.addCampaign === 2,
        current: $options.getCurrentClass === 'addCampaign'
      })
    }, [_createElementVNode("span", _hoisted_37, [$options.welcomeDashboardItems.addCampaign === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_38)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($options.welcomeDashboardItems.addCampaign === 2 ? "" : 4), 1)]), _createTextVNode(" " + _toDisplayString($options.welcomeDashboardItems.addCampaign === 0 ? "Create your first campaign" : $options.welcomeDashboardItems.addCampaign === 1 ? "Publish your campaign now" : "The first campaign created") + " ", 1), _hoisted_39], 10, _hoisted_36)])]),
    _: 1
  }, 8, ["container", "show"])], 512), [[_vShow, parseInt($options.isWelcomeDashboard) !== 2]]), $data.loginData?.plan != '3' && parseInt($options.isWelcomeDashboard) === 2 ? (_openBlock(), _createElementBlock("li", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createVNode(_component_b_link, {
    class: "nav-link",
    to: "/change-plan"
  }, {
    default: _withCtx(() => [_hoisted_42, _hoisted_43]),
    _: 1
  })])])) : _createCommentVNode("", true), $data.permission < 3 && $data.allowTransaction ? (_openBlock(), _createElementBlock("li", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createVNode(_component_b_link, {
    class: "nav-link",
    to: {
      path: '/transactional/dashboard'
    }
  }, {
    default: _withCtx(() => [_hoisted_46, _hoisted_47]),
    _: 1
  })])])) : _createCommentVNode("", true), _createElementVNode("li", _hoisted_48, [_createVNode(_component_b_link, {
    id: "popover-target-1",
    class: _normalizeClass(["nav-link drop-ico", {
      active: $data.active || _ctx.$route.path.indexOf('/account') != -1
    }]),
    onClick: _cache[5] || (_cache[5] = $event => $data.active = !$data.active)
  }, {
    default: _withCtx(() => [$data.showProfilePic == 'true' ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "ico-sidebar profile-holder rounded-circle",
      style: _normalizeStyle({
        'background-image': $data.profilePicUrl
      })
    }, null, 4)) : _createCommentVNode("", true), $data.showProfilePic == 'false' ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString($options.getFirstLetter($data.clientName)), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_50, [_createElementVNode("p", _hoisted_51, _toDisplayString($data.clientName), 1)])]),
    _: 1
  }, 8, ["class"]), _createVNode(_component_BPopover, {
    onHidden: _cache[8] || (_cache[8] = $event => $data.active = false),
    ref: "popover",
    target: "popover-target-1",
    click: "",
    placement: "right",
    class: "popover-nav"
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "popover-profile-container",
      onClick: _cache[7] || (_cache[7] = (...args) => _ctx.close && _ctx.close(...args))
    }, [_createElementVNode("ul", _hoisted_52, [_createVNode(_component_b_dropdown_item, {
      disabled: ""
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [$data.showProfilePic == 'true' ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("span", {
        class: "profile-holder rounded-circle",
        style: _normalizeStyle({
          'background-image': $data.profilePicUrl
        })
      }, null, 4)])])) : _createCommentVNode("", true), $data.showProfilePic == 'false' ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_createElementVNode("span", _hoisted_58, _toDisplayString($options.getFirstLetter($data.clientName)), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_59, [_createVNode(_component_b_row, null, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          class: "font-15 text-sub-head fw-bold text-truncate"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.clientName), 1)]),
          _: 1
        }), _createVNode(_component_b_col, {
          cols: "auto",
          class: "ml-auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_link, {
            class: "font-13 account-role text-decoration-none",
            to: "/account/profile"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.clientRole), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_b_row, null, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12",
          class: "font-13 text-600 text-truncate max-w-250"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.username), 1)]),
          _: 1
        })]),
        _: 1
      })])])])]),
      _: 1
    }), _createVNode(_component_b_dropdown_item, {
      to: "/account/profile"
    }, {
      default: _withCtx(() => [_hoisted_60]),
      _: 1
    }), $data.permission < 3 && !$data.loginData.isLiftime ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
      key: 0,
      to: "/account/invoices"
    }, {
      default: _withCtx(() => [_hoisted_61]),
      _: 1
    })) : _createCommentVNode("", true), $data.permission < 3 ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
      key: 1,
      to: "/account"
    }, {
      default: _withCtx(() => [_hoisted_62]),
      _: 1
    })) : _createCommentVNode("", true), $data.permission < 3 ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
      key: 2,
      to: "/account/domains"
    }, {
      default: _withCtx(() => [_hoisted_63]),
      _: 1
    })) : _createCommentVNode("", true), $data.permission < 2 ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
      key: 3,
      to: "/logs/contact/import"
    }, {
      default: _withCtx(() => [_hoisted_64]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_b_dropdown_item, {
      href: "https://help.mailercloud.com",
      target: "_blank"
    }, {
      default: _withCtx(() => [_hoisted_65]),
      _: 1
    }), _createVNode(_component_b_dropdown_divider, {
      class: "my-2"
    }), _createVNode(_component_b_dropdown_item, {
      onClick: _cache[6] || (_cache[6] = $event => $options.logout())
    }, {
      default: _withCtx(() => [_hoisted_66]),
      _: 1
    }), _createVNode(_component_b_dropdown_divider, {
      class: "mt-2"
    })])])]),
    _: 1
  }, 512)])])]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", null, [_createVNode(_component_b_row, null, {
    default: _withCtx(() => [_createVNode(_component_b_col, {
      class: "text-center"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: "menu-toggle-ico",
        onClick: _cache[9] || (_cache[9] = $event => $data.mobileMenu = true)
      }, _hoisted_69), _createVNode(_component_b_link, {
        href: "/"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: require('@/assets/img/icons/menu/mailercloud/brand-logo.svg'),
          class: "navbar-brand-img",
          height: "26",
          alt: "Mailercloud"
        }, null, 8, _hoisted_70)]),
        _: 1
      }), $data.mobileMenu ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_createVNode(_component_b_link, {
        href: "/"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: require('@/assets/img/icons/menu/mailercloud/brand-logo.svg'),
          class: "navbar-brand-img mb-5",
          height: "26",
          alt: "Mailercloud"
        }, null, 8, _hoisted_72)]),
        _: 1
      }), _createElementVNode("div", {
        class: "menu-mobile-close",
        onClick: _cache[10] || (_cache[10] = $event => $data.mobileMenu = false)
      }, _hoisted_74), _createElementVNode("div", _hoisted_75, [_createVNode(_component_mob_menu, {
        onSelected: _cache[11] || (_cache[11] = $event => $data.mobileMenu = false)
      }), _createElementVNode("ul", _hoisted_76, [_createElementVNode("li", _hoisted_77, [_createElementVNode("span", {
        class: _normalizeClass(["nav-link drop-ico", {
          active: $data.active || _ctx.$route.path.indexOf('/account') != -1
        }]),
        onClick: _cache[12] || (_cache[12] = $event => $data.userCardShow = true)
      }, [$data.showProfilePic == 'true' ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "ico-sidebar profile-holder rounded-circle",
        style: _normalizeStyle({
          'background-image': $data.profilePicUrl
        })
      }, null, 4)) : _createCommentVNode("", true), $data.showProfilePic == 'false' ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString($options.getFirstLetter($data.clientName)), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_79, [_createElementVNode("p", _hoisted_80, _toDisplayString($data.clientName), 1)])], 2)])]), $data.userCardShow ? (_openBlock(), _createElementBlock("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createElementVNode("div", {
        class: "user-card-close",
        onClick: _cache[13] || (_cache[13] = $event => $data.userCardShow = false)
      }, _hoisted_84), _createElementVNode("ul", _hoisted_85, [_createVNode(_component_b_dropdown_item, {
        disabled: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [$data.showProfilePic == 'true' ? (_openBlock(), _createElementBlock("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("span", {
          class: "profile-holder rounded-circle",
          style: _normalizeStyle({
            'background-image': $data.profilePicUrl
          })
        }, null, 4)])])) : _createCommentVNode("", true), $data.showProfilePic == 'false' ? (_openBlock(), _createElementBlock("div", _hoisted_90, [_createElementVNode("span", _hoisted_91, _toDisplayString($options.getFirstLetter($data.clientName)), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_92, [_createVNode(_component_b_row, null, {
          default: _withCtx(() => [_createVNode(_component_b_col, {
            cols: "6",
            class: "font-15 text-sub-head mb-0 fw-bold text-truncate"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.clientName), 1)]),
            _: 1
          }), _createVNode(_component_b_col, {
            cols: "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_b_link, {
              class: "font-13 account-role text-decoration-none",
              to: "/account/profile"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString($data.clientRole), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_b_row, null, {
          default: _withCtx(() => [_createVNode(_component_b_col, {
            class: "font-13 text-500 text-truncate",
            cols: "12"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.username), 1)]),
            _: 1
          })]),
          _: 1
        })])])])]),
        _: 1
      }), _createVNode(_component_b_dropdown_divider, {
        class: "mt-2 profile-border-none"
      }), _createVNode(_component_b_dropdown_item, {
        to: "'/account/profile'"
      }, {
        default: _withCtx(() => [_hoisted_93]),
        _: 1
      }), $data.permission < 3 && !$data.loginData.isLiftime ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
        key: 0,
        to: "/account/invoices"
      }, {
        default: _withCtx(() => [_hoisted_94]),
        _: 1
      })) : _createCommentVNode("", true), $data.permission < 3 ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
        key: 1,
        to: "/account"
      }, {
        default: _withCtx(() => [_hoisted_95]),
        _: 1
      })) : _createCommentVNode("", true), $data.permission < 3 ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
        key: 2,
        to: "/account/domains"
      }, {
        default: _withCtx(() => [_hoisted_96]),
        _: 1
      })) : _createCommentVNode("", true), $data.permission < 2 ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
        key: 3,
        to: "/logs/contact/import"
      }, {
        default: _withCtx(() => [_hoisted_97]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_b_dropdown_item, {
        href: "https://help.mailercloud.com",
        target: "_blank",
        onClick: _cache[14] || (_cache[14] = $event => $data.mobileMenu = false)
      }, {
        default: _withCtx(() => [_hoisted_98]),
        _: 1
      }), _createVNode(_component_b_dropdown_divider, {
        class: "my-2"
      }), _createVNode(_component_b_dropdown_item, {
        onClick: _cache[15] || (_cache[15] = $event => $options.logout())
      }, {
        default: _withCtx(() => [_hoisted_99]),
        _: 1
      }), _createVNode(_component_b_dropdown_divider, {
        class: "mt-2"
      })])])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  })])]), _hoisted_100], 2);
}